let rowDataServerSide;

function MyDatasource() {
}

MyDatasource.prototype.getRows = (params) => {
  const rowsThisPage = rowDataServerSide.slice(params.startRow, params.endRow);
  params.successCallback(rowsThisPage, rowDataServerSide.length);
};




// WEBPACK FOOTER //
// ./src/datasources/datasource.js